module.exports = __webpack_public_path__ + "img/transbank.53b9689c.png";